import template   from './products.html'
import controller from './products.controller'
import './products.styl'

let component = {
  restrict: 'E',
  bindings: {
    category: '<',
    filter: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products/products.component.js